import React, { FC } from "react";
import { TooltipProps } from "antd";
import { TextWrapper } from "./elements";
import { generateStartSuffixForEllipsis } from "../../../utils/helpers/strings";

type TextEllipsisProps = {
  content: string;
  tooltip?: TooltipProps;
  onClick?: any;
};

const TextEllipsis: FC<TextEllipsisProps> = (props) => {
  const { onClick, tooltip, content, } = props;
  const { start, suffix } = generateStartSuffixForEllipsis(content);

  const defaultTooltipProps: TooltipProps = { 
    title: content,
    placement: "bottomLeft",
    overlayStyle: {
      maxWidth: "800px",
    },
    mouseLeaveDelay: 0, 
    ...tooltip,
  };

  return (
    <TextWrapper
      ellipsis={{ 
        tooltip: defaultTooltipProps, 
        suffix: suffix,
      }} 
      onClick={onClick}
      { ...props }
    >
      { start }
    </TextWrapper>
  );
};

export default TextEllipsis;
